export const DeliveryBoxIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" fill="none">
			<path
				d="M13 3V11L10.3333 11.8889M13 3L7 5M13 3L7 1L1 3M7 13V5M7 13L1 11V3M7 13L10.3333 11.8889M7 5L4 4M1 3L4 4M10.3333 8.33333V11.8889M4 4V8.33333M4 4L7 3"
				stroke="#0E0E0E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
